<template>
  <div>
    <!-- BEGIN FORM-->
    <form id="form_quiz_create" class="form-horizontal col-xs-12 absolute-parlsey-errors">
        <div class="form-body col-xs-12">
          <div class="col-xs-12 col-sm-6">
            <div class="form-group form-md-line-input">
                <label class="col-md-3 control-label">Titre
                    <span class="required" aria-required="true">*</span>
                </label>
                <div class="col-md-9">
                    <input type="text" class="form-control" placeholder="" v-model="quiz.title"  required :disabled="quiz.slug">
                    <div class="form-control-focus"> </div>
                    <span class="help-block">Le titre du questionnaire ne pourra pas être modifié après l'enregistrement.</span>
                </div>
            </div>
            <div class="form-group form-md-line-input">
                <label class="col-md-3 control-label">Date limite des réponses
                  <!-- <span class="required" aria-required="true">*</span> -->
                </label>
                <div class="col-md-9">
                    <input class="form-control form-control-inline date-picker" id="date_deadline" type="text" value="">
                    <!-- <input type="date" class="form-control" placeholder="" v-model="quiz.date_deadline"> -->
                    <div class="form-control-focus"> </div>
                    <span class="help-block">Les utilisateurs pourront encore répondre le jour de la date limite.</span>
                </div>
            </div>

            <div class="form-group form-md-line-input">
                <label class="col-md-3 control-label">Instructions
                    <!-- <span class="required" aria-required="true">*</span> -->
                </label>
                <div class="col-md-9">
                    <textarea type="text" class="form-control" placeholder="" v-model="quiz.instructions"></textarea>
                    <div class="form-control-focus"> </div>
                </div>
            </div>

            <div class="form-group form-md-line-input">
                <label class="col-md-3 control-label">Texte de conclusion
                    <!-- <span class="required" aria-required="true">*</span> -->
                </label>
                <div class="col-md-9">
                    <textarea type="text" class="form-control" placeholder="" v-model="quiz.conclusion"></textarea>
                    <div class="form-control-focus"> </div>
                </div>
            </div>
          </div>

          <div class="col-sm-6 col-xs-12">
            <h5>Entreprise</h5>
            <div class="form-group form-md-line-input">
              <label class="col-md-2 control-label">Nom
                <span class="required" aria-required="true">*</span>
              </label>
                <div class="col-md-10" v-if="quiz.company">
                    <input type="text" class="form-control" v-model="quiz.company.name" required>
                    <div class="form-control-focus"> </div>
                </div>
            </div>

            <!-- <hr> -->

            <h5>Groupes</h5>
            <em class="info col-xs-12"><span aria-hidden="true" class="icon-info"></span> 0 équivaut à un nombre illimité de participants.</em>
            <div class="form-group form-md-line-input" v-for="(group,index_groups) in quiz.groups">
              <label class="col-xs-2 control-label">Nom
                <span class="required" aria-required="true">*</span>
              </label>
              <!-- <div class="col-xs-4">
                  <input type="text" class="form-control" v-model="group.name" required data-parsley-errors-messages-disabled>
                  <div class="form-control-focus"> </div>
              </div> -->
              <div class="col-xs-4">
                <div class="input-group">
                  <input type="text" class="form-control" v-model="group.name" required data-parsley-errors-messages-disabled>
                  <div class="form-control-focus"> </div>
                </div>
              </div>
              <label class="col-xs-3 control-label">Participants
                <span class="required" aria-required="true">*</span>
              </label>
              <div class="col-xs-3">
                  <input type="number" class="form-control" min="0" v-model="group.nb_participants" required data-parsley-errors-messages-disabled>
                  <div class="form-control-focus"> </div>
              </div>
            </div>

            <a style="white-space: nowrap" v-on:click="quiz.groups.push({name:'',nb_participants:0});forceUpdate()" class="ml-55"><span aria-hidden="true" class="icon-plus"></span> Ajouter un groupe</a>
            <a style="white-space: nowrap" v-if="quiz.groups" v-show="quiz.groups.length > 1" v-on:click="removeGroup()" class="ml-55 text-danger"><span aria-hidden="true" class="icon-close"></span> Retirer le dernier groupe</a>
          </div>

        </div>

    </form>
    <!-- END FORM-->
  </div>
</template>


<script>

  import users from '../../requests/users.js'
  import quizzes from '../../requests/quizzes.js'

  export default {
    props: ["quiz"],
    data(){
      return{
      }
    },
    mounted:function(){
      this.reinit();
    },
    watch:{
        'quiz.groups':function(){
            this.$forceUpdate();
        },
        '$route': function() {
            this.reinit(true);
        }
    },
    methods:{
      forceUpdate(){
        this.$forceUpdate();
      },
      reinit(forceReload = false){

        $('.date-picker').datepicker({
          format: 'dd/mm/yyyy',
          language:'fr'
        });
        if(this.quiz.date_deadline && !forceReload) {
            console.error(this.quiz.date_deadline)
            $("#date_deadline").datepicker("setDate",new Date(this.quiz.date_deadline));
        } else {
            $("#date_deadline").datepicker("setDate","");
        }

      },
      removeGroup(){
        this.quiz.groups.pop();
        this.$forceUpdate();
      }
    },
    beforeRouteLeave (to, from, next) {
      // called when the route that renders this component is about to
      // be navigated away from.
      // has access to `this` component instance.

      // Réinit le quiz si on est sur la route quizzes_edit et qu'on click sur quizzes_create.
      this.reinit();
      next();
    }
  }
</script>

<style scoped>

.info{
  font-size: 13px;
  color:gray;
  text-align: right;
  margin-top: -10px;
  margin-bottom: 10px;
}

</style>



// WEBPACK FOOTER //
// create_quiz.vue?0d960373